import React from "react";
import { InView } from 'react-intersection-observer';

const OurMission = () => {
  return (
    <div className="bg-gray-950 py-20">
      <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Section - Image */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 flex justify-center ${inView ? 'animate__animated animate__fadeInLeft' : 'opacity-0'}`}
            >
              <img
                src="https://www.sci.jfn.ac.lk/wp-content/uploads/2021/09/mission.gif"
                alt="Our Mission"
                className="w-full max-w-xl h-auto object-cover rounded-2xl shadow-2xl shadow-purple-500/20"
              />
            </div>
          )}
        </InView>

        {/* Right Section - Content */}
        <InView triggerOnce={true} threshold={0.5}>
          {({ inView, ref }) => (
            <div
              ref={ref}
              className={`lg:w-1/2 text-left ${inView ? 'animate__animated animate__fadeInRight' : 'opacity-0'}`}
            >
              <h2 className="text-4xl sm:text-5xl font-bold mb-8">
                <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
                  Our Mission
                </span>
              </h2>
              <div className="space-y-6">
                <p className="text-gray-300 text-lg leading-relaxed">
                  Our mission is to empower every business, entrepreneur, and creator with easy-to-use design tools that help them grow their brand without needing professional design skills.
                </p>
                <p className="text-gray-400 text-lg leading-relaxed">
                  We strive to save time, reduce effort, and provide high-quality, ready-made creative solutions that enable users to stay active on social media every day.
                </p>
                <p className="text-gray-300 text-lg font-semibold">
                  Our goal is to become India's most trusted platform for daily promotional and festival marketing.
                </p>
              </div>
            </div>
          )}
        </InView>
      </div>
    </div>
  );
};

export default OurMission;